<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <p class="d-flex align-center flex-wrap text-body-1 font-weight-regular">
          <span class="mediaTitle d-block"> <v-icon left>mdi-folder-multiple-image</v-icon>{{ $t("PANEL.MEDIA.MEDIA_HEADER.TITLE") }} </span>
          <v-btn small color="primary" class="ml-8" @click="addMedia = true">
            <v-icon left>mdi-plus</v-icon>
            {{ $t("PANEL.MEDIA.MEDIA_HEADER.ACTION_BTN") }}
          </v-btn>
        </p>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="py-0">
        <component :is="mediaListComponent" :update="updateMediaList"></component>
      </v-col>
    </v-row>
    <add-media v-model="addMedia" @added="updateMediaList = !updateMediaList" />
  </v-container>
</template>

<script>
import AddMedia from "./AddMedia.vue";
import MediaList from "./MediaList.vue";

export default {
  components: { AddMedia },
  name: "MediaFinder",
  data: () => ({
    addMedia: false,
    updateMediaList: false,
    mediaListComponent: ""
  }),
  mounted() {
    let self = this,
      preload = [
        new Promise(resolve => {
          resolve(self.$store.dispatch("Media/getAcceptFilesList"));
        })
      ];

    preload.push(
      new Promise(resolve => {
        resolve(self.$store.dispatch("Media/getAcceptBaseImages"));
      })
    );

    preload.push(
      new Promise(resolve => {
        resolve(self.$store.dispatch("Media/getMediaListTypes"));
      })
    );

    Promise.all(preload).then(() => {
      this.mediaListComponent = MediaList;
    });
  }
};
</script>

<style></style>
